import { createRef } from 'react'
import { CustomRouteObject } from 'react-router-dom'

import { routeNamesPaths } from '@shared/constants'

export const DataProcessingPageRouter: CustomRouteObject = {
  path: routeNamesPaths.dataProcessing,
  lazy: async () => {
    const { DataProcessing } = await import('./ui')

    return {
      Component: DataProcessing,
    }
  },
  nodeRef: createRef(),
}
